export type DetectionMode = 'manual' | 'automatic' | '';

export interface FraudDetectorFormValues {
  detection_mode: DetectionMode;
  auto_reject_enabled: boolean;
  ats_rejection_reason_id: number | null;
  sendRejectEmail: boolean;
  selectedTemplate: Record<string, unknown> | null;
  from: string;
  fromUserObject: Record<string, unknown> | null;
  subject: string;
  body: string;
  cc: string[];
  bcc: string[];
  attachments: unknown[];
  scheduleEmail: boolean;
  sendAfter: number;
  scheduleTime: string | null;
  scheduleTimezone: unknown;
  survey: unknown;
}

export const FRAUD_DETECTOR_FORM_DEFAULTS: FraudDetectorFormValues = {
  detection_mode: '',
  auto_reject_enabled: false,
  ats_rejection_reason_id: null,
  sendRejectEmail: false,
  selectedTemplate: null,
  from: '',
  fromUserObject: null,
  subject: '',
  body: '',
  cc: [],
  bcc: [],
  attachments: [],
  scheduleEmail: true,
  sendAfter: 1,
  scheduleTime: null,
  scheduleTimezone: null,
  survey: null,
};
